import { post } from '@/lib/http-adapter';

export type MetaEventName =
  | 'PageView'
  | 'ViewContent'
  | 'AddToCart'
  | 'InitiateCheckout'
  | 'Purchase'
  | 'Schedule';

export type MetaUserData = {
  em?: string[];
  ph?: string[];
  fn?: string[];
  ln?: string[];
  country?: string[];
  external_id?: string[];
  fbp?: string;
  fbc?: string;
};

export type MetaCustomData = {
  currency?: string;
  value?: number;
  content_name?: string;
  content_type?:
    | 'class'
    | 'class_pack'
    | 'subscription'
    | 'topup'
    | 'gift_card';
  content_ids?: string[];
  num_items?: number;
};

export type MetaUserSource = {
  email?: string | null;
  phone?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  country_code?: string | null;
  user_id?: string | null;
};

export type MetaAttribution = {
  fbp?: string;
  fbc?: string;
  oppref?: string;
  obref?: string;
  client_user_agent?: string;
};

export type MetaConversionPayload = {
  event_name: MetaEventName;
  event_id: string;
  event_time: number;
  event_source_url: string;
  user_data: MetaUserData;
  custom_data?: MetaCustomData;
};

export const sendMetaConversion = async (
  payload: MetaConversionPayload
): Promise<void> => {
  try {
    await post('/public/tracking/meta', payload);
  } catch {
    // Best-effort marketing beacon: ad-blockers and navigation cancellation
    // routinely kill it. Not an app error — swallow so it can't surface as an
    // unhandled rejection (PostHog capture_exceptions).
  }
};

// The click id itself never leaves the page: the status light only needs to
// know one was there.
export type WebsiteLinkSignalPayload = {
  marker: string | null;
  has_fbclid: boolean;
  referrer_origin: string | null;
};

export const sendWebsiteLinkSignal = async (
  payload: WebsiteLinkSignalPayload
): Promise<void> => {
  try {
    await post('/public/tracking/website-link', payload);
  } catch {
    // A display signal for the studio's status light; losing one is harmless.
  }
};
